<div class="loader">
  <progress
    class="loader__progress"
    max="100"
    [value]="percentage()"
  ></progress>
  <span class="loader__percentage">{{ percentage() }}%</span>
</div>
